import { forwardRef } from '@angular/core';

export class Utilities {
	/**
	 * Pulisce le url eliminando gli slash aggiuntivi
	 * @param url url da pulire
	 * @example https://www.google.com/pippo//paperino -> https://www.google.com/pippo/paperino
	 * @example http://www.google.com:9876//pippo/paperino?param=1 -> http://www.google.com:9876/pippo/paperino?param=1
	 */
	public static CleanUrl(url: string): string {
		let returnUrl = '';
		const tmpUrl = new URL(url);
		returnUrl = tmpUrl.protocol + '//' + tmpUrl.host;
		if (tmpUrl.port) {
			returnUrl = returnUrl + ':' + tmpUrl.port;
		}

		returnUrl += tmpUrl.pathname.split('//').join('/') + tmpUrl.search;
		return returnUrl;
	}
}
